import React from "react";

const ChevronDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <g clip-path="url(#clip0_9_786)">
        <path
          d="M8.9775 3.30816C8.8603 3.19099 8.70135 3.12516 8.53563 3.12516C8.3699 3.12516 8.21095 3.19099 8.09375 3.30816L5 6.40191L1.90625 3.30816C1.78837 3.19431 1.6305 3.13131 1.46662 3.13273C1.30275 3.13416 1.14599 3.19989 1.03011 3.31577C0.914234 3.43165 0.848504 3.58841 0.84708 3.75228C0.845656 3.91615 0.908652 4.07403 1.0225 4.19191L4.55813 7.72753C4.67533 7.8447 4.83427 7.91052 5 7.91052C5.16573 7.91052 5.32467 7.8447 5.44188 7.72753L8.9775 4.19191C9.09467 4.0747 9.16049 3.91576 9.16049 3.75003C9.16049 3.5843 9.09467 3.42536 8.9775 3.30816Z"
          fill="#45464D"
        />
      </g>
      <defs>
        <clipPath id="clip0_9_786">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(10 10) rotate(180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChevronDownIcon;
